import { render, staticRenderFns } from "./ScadaThreeTabData.vue?vue&type=template&id=37534a8a&"
import script from "./ScadaThreeTabData.vue?vue&type=script&lang=js&"
export * from "./ScadaThreeTabData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
